//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RightDrawer from "@/components/RightDrawer/Filters.vue";
import { EventBus } from "@/event-bus.js";
export default {
  name: "Filters",
  components: {
    RightDrawer,
  },
  mounted: function () {
    let pathTokens = this.$router.currentRoute.path.split("/");
    this.tab = pathTokens[pathTokens.length - 1];
    EventBus.$on("loadingState", (loading) => {
      this.loading = loading;
    });
  },
  data: function () {
    return {
      tab: null,
      daysWithoutSales: null,
      daysCoverage: null,
      abcClasses: { a: true, b: true, c: true, notPresent: true },
      cardexStatus: { active: true, inactive: true },
      loading: false,
    };
  },
  methods: {
    clearFilters: function () {
      this.$store.commit("clearFilters");
    },
    setDaysCoverage: function () {
      this.$store.commit("setCoverageDaysView", this.daysCoverage);
    },
    setDaysWithoutSales: function () {
      this.$store.commit("setDaysWithoutSales", this.daysWithoutSales);
    },
  },
  watch: {
    abcClasses: {
      handler() {
        this.$store.commit("setAbcSelected", this.abcClasses);
      },
      deep: true
    },
    cardexStatus: {
      handler() {
        this.$store.commit("setCardexStatus", this.cardexStatus);
      },
      deep: true
    },
    daysWithoutSales: function (val) {
      if (val < 0) {
        this.daysWithoutSales = 0;
      }
    },
    daysCoverage: function (val) {
      if (val < 0) {
        this.daysCoverage = 0;
      }
    },
  },
};
